"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/toConsumableArray"));

require("core-js/modules/es6.number.constructor");

var _goodsLink = _interopRequireDefault(require("../../../recommend/compoments/goodsLink"));

var _goodsDialog = _interopRequireDefault(require("@/components/goodsDialog.vue"));

var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    goodsLink: _goodsLink.default,
    goodsDialog: _goodsDialog.default,
    cropUpload: _cropUpload.default
  },
  props: {
    contentType: {
      type: String,
      default: 'goods'
    },
    goodsNum: {
      type: Number
    },
    title: {
      type: String
    },
    formData: {
      type: Object,
      default: {}
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      goodsList: [],
      goods: [{
        imgurl: ''
      }, {
        imgurl: ''
      }]
    };
  },
  methods: {
    // 添加商品
    openSelect: function openSelect() {
      this.$refs.goodsDialog.dialogVisible = true;
      this.$refs.goodsDialog.selectItems = (0, _toConsumableArray2.default)(this.goodsList);
    },
    // 设置选中
    setSelect: function setSelect(goodsList) {
      this.goodsList = goodsList;
    },
    // 升序
    upSort: function upSort(index) {
      if (index === 0) {
        return;
      }

      var item = this.goodsList[index];
      this.$set(this.goodsList, index, this.goodsList[index - 1]);
      this.$set(this.goodsList, index - 1, item);
    },
    // 降序
    downSort: function downSort(index) {
      if (index === this.goodsList.length - 1) {
        return;
      }

      var item = this.goodsList[index];
      this.$set(this.goodsList, index, this.goodsList[index + 1]);
      this.$set(this.goodsList, index + 1, item);
    },
    // 删除商品
    deleteGoods: function deleteGoods(index) {
      this.goodsList.splice(index, 1);
    }
  }
};
exports.default = _default;